import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  min-height: ', 'px;\n  outline: none;\n  width: 100%;\n'], ['\n  align-items: center;\n  display: flex;\n  min-height: ', 'px;\n  outline: none;\n  width: 100%;\n']);

import styled from 'styled-components';
import { gridSize, math } from '@atlaskit/theme';

var Trigger = styled.div(_templateObject, math.multiply(gridSize, 4.5));

Trigger.displayName = 'SingleSelectTrigger';

export default Trigger;